import { IPersonalInfo } from 'types';
import { countries } from 'data';

export const getCountryOfVisaApplication = (personalInfo: IPersonalInfo): string => {
  if (personalInfo.applyingFromHomeCountry) {
    return countries.find(i => i.nationality === personalInfo.nationality)?.countryName ?? '';
  }

  if (personalInfo.countryOfVisaApplication) return personalInfo.countryOfVisaApplication;

  return (
    countries.find(i => i.nationality === personalInfo.nationality)?.countryName ??
    personalInfo.countryOfVisaApplication ??
    ''
  );
};
